import { JSX, useEffect } from "react";

const LicenseInfo = (): JSX.Element => {
  const licenseText = "This information isn't included in your current license.";
  const descriptionText = "To learn more about gaining access and enhancing your network management operations, please complete this form.";

  /* oxlint-disable @typescript-eslint/no-explicit-any */
  useEffect(() => {
    const loadMarketoForm = () => {      
      // Check if script is already loaded
      if (document.querySelector('script[src*="forms2.min.js"]')) {
        if ((window as any).MktoForms2) {
          (window as any).MktoForms2.loadForm("https://go.questanalytics.com", "598-MKX-845", 1690);
        }
        return;
      }

      // Load the Marketo script
      const script = document.createElement('script');
      script.src = 'https://go.questanalytics.com/js/forms2/js/forms2.min.js';
      script.async = true;
      script.onload = () => {
        // Wait a bit for MktoForms2 to be available
        setTimeout(() => {
          if ((window as any).MktoForms2) {
            (window as any).MktoForms2.loadForm("https://go.questanalytics.com", "598-MKX-845", 1690);
          }
        }, 100);
      };
      document.body.appendChild(script);
    };

    loadMarketoForm();
  }, []);
   /* oxlint-enable @typescript-eslint/no-explicit-any */

  return (
    <>
      <b>{licenseText}</b>
      <p>{descriptionText}</p>
      <div>
        <form id="mktoForm_1690"></form>
      </div>
    </>
  );
};

export { LicenseInfo };